import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { GlassCard } from '../components/ui/GlassCard';
import { Check } from 'lucide-react';

export const Product = () => {
  const { t } = useTranslation();

  const features = [
    t('product.feature1'),
    t('product.feature2'),
    t('product.feature3'),
    t('product.feature4'),
    t('product.feature5'),
    t('product.feature6'),
  ];

  return (
    <div className="container mx-auto px-6 py-20">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-4xl mx-auto text-center mb-20"
      >
        <h1 className="text-5xl font-display font-bold mb-6">{t('product.title')}</h1>
        <p className="text-xl text-gray-400">
          {t('product.subtitle')}
        </p>
      </motion.div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-20">
        <GlassCard className="p-10">
          <h3 className="text-2xl font-display font-bold mb-6 text-glass-cyan">{t('product.coreCapabilities')}</h3>
          <ul className="space-y-4">
            {features.map((feature, i) => (
              <li key={i} className="flex items-start gap-3 text-gray-300">
                <Check className="w-5 h-5 text-glass-cyan shrink-0 mt-1" />
                {feature}
              </li>
            ))}
          </ul>
        </GlassCard>

        <div className="space-y-8">
          <GlassCard className="p-8 border-l-4 border-l-white">
            <h4 className="text-xl font-bold mb-2">{t('product.transparencyTitle')}</h4>
            <p className="text-gray-400">
              {t('product.transparencyDesc')}
            </p>
          </GlassCard>

          <GlassCard className="p-8 border-l-4 border-l-glass-cyan">
            <h4 className="text-xl font-bold mb-2">{t('product.enterpriseTitle')}</h4>
            <p className="text-gray-400">
              {t('product.enterpriseDesc')}
            </p>
          </GlassCard>
        </div>
      </div>
    </div>
  );
};
